import { getConnector } from '../../services/Connector';
import { Product } from '../../models/Product';
import './ActiveHelpProductList.less';

export type ActiveHelpProductListProps = {
    products: Product[];
};

const ActiveHelpProductList = ({ products }: ActiveHelpProductListProps) => (
    <div className={`bri-ActiveHelpProductList`}>
        {products.slice(0, 4).map(product => (
            <img
                src={getConnector().getScaledImage(product.images[0].url, 44)}
                title={product.name}
            />
        ))}
    </div>
);

export default ActiveHelpProductList;
